import { Component } from '@angular/core';

@Component({
  selector: 'controller-software',
  templateUrl: './controller-software.component.html',
  styleUrls: ['./controller-software.component.scss']
})
export class ControllerSoftwareComponent {

}
